import { BASE_IMAGE_URL } from '../../constants';

export const VerticalsEnum = {
  CreditCards: 'credit_cards',
  Insurance: 'insurance',
  Mortgages: 'mortgages',
  PersonalLoans: 'personal_loans',
  business_loans: 'business_loans',
  Banking: 'banking',
  Investing: 'investing',
  StudentLoans: 'student_loans',
  FinancialAdvisor: 'financial_advisor',
};

export const SHOPPING_TABS = [
  VerticalsEnum.Insurance,
  VerticalsEnum.CreditCards,
  VerticalsEnum.Mortgages,
  VerticalsEnum.PersonalLoans,
  VerticalsEnum.business_loans,
  VerticalsEnum.FinancialAdvisor,
];

export const SHOPPING_TABS_CONTENT = {
  [VerticalsEnum.Insurance]: {
    label: 'INSURANCE',
    backgroundColor: '#f9fff9',
    mainText:
      'Find auto insurance at a price that works for you.',
    secondaryText: 'Get matched with top providers in minutes.',
    cta: {
      label: 'Best Car Insurance',
      url: 'https://nerdwallet.com/p/insurance/car-insurance',
    },
    images: {
      desktopURL: `${BASE_IMAGE_URL}/superbowl/heroes/shopping-1440-insurance-2x.png`,
      tabletURL: `${BASE_IMAGE_URL}/superbowl/heroes/shopping-768-insurance-2x.png`,
      mobileAltURL: `${BASE_IMAGE_URL}/superbowl/shopping_module_insurance.png`,
      alt: 'Insurance Hero Image',
    },
    analytics: {
      tab: 'hp_quiz_ins_tab',
      cta: 'hp_quiz_ins_cta',
    },
  },
  [VerticalsEnum.CreditCards]: {
    label: 'CREDIT CARDS',
    backgroundColor: '#f2fff2',
    mainText: 'Our Nerds researched 400+ credit cards so you don’t have to.',
    cta: {
      label: 'Find Credit Cards',
      url: 'https://www.nerdwallet.com/recommend/CreditScore?trk_location=cc_super_bowl',
    },
    images: {
      desktopURL: `${BASE_IMAGE_URL}/superbowl/heroes/shopping-1440-credit-cards-2x.png`,
      tabletURL: `${BASE_IMAGE_URL}/superbowl/heroes/shopping-768-credit-cards-2x.png`,
      mobileAltURL: `${BASE_IMAGE_URL}/superbowl/shopping_module_credit_card.png`,
      alt: 'Credit Card Hero Image',
    },
    analytics: {
      tab: 'hp_quiz_cc_tab',
      cta: 'hp_quiz_cc_cta',
    },
  },
  [VerticalsEnum.Mortgages]: {
    label: 'MORTGAGES',
    backgroundColor: '#DCF5E9',
    mainText: 'Our Nerds researched 50+ mortgage lenders so you don’t have to.',
    cta: {
      label: 'Find Mortgage Rates',
      url: 'https://www.nerdwallet.com/prequalify/mortgage-purchase/apply?affiliateName=NerdWallet&affiliateId=1333&subId1=organic&subId2=mortgage_refi_superbowl&subId3=homepage',
    },
    images: {
      desktopURL: `${BASE_IMAGE_URL}/superbowl/heroes/shopping-1440-mortgage-2x.png`,
      tabletURL: `${BASE_IMAGE_URL}/superbowl/heroes/shopping-768-mortgage-2x.png`,
      mobileAltURL: `${BASE_IMAGE_URL}/superbowl/shopping_module_mortgages.png`,
      alt: 'Mortgages Hero Image',
    },
    analytics: {
      tab: 'hp_quiz_mr_tab',
      cta: 'hp_quiz_mr_cta',
    },
  },
  [VerticalsEnum.PersonalLoans]: {
    label: 'PERSONAL LOANS',
    backgroundColor: '#CEF0E1',
    mainText:
      'Our Nerds researched 35+ personal loan lenders so you don’t have to.',
    cta: {
      label: 'Find Personal Loans',
      url: 'https://www.nerdwallet.com/prequalify/personal-loan/apply?affiliateName=NerdWallet&affiliateId=1333&subId1=organic&subId2=pl_superbowl&subId3=homepage',
    },
    images: {
      desktopURL: `${BASE_IMAGE_URL}/superbowl/heroes/shopping-1440-personal-loans-2x.png`,
      tabletURL: `${BASE_IMAGE_URL}/superbowl/heroes/shopping-768-personal-loans-2x.png`,
      mobileAltURL: `${BASE_IMAGE_URL}/superbowl/shopping_module_personal_loans.png`,
      alt: 'Personal Loans Hero Image',
    },
    analytics: {
      tab: 'hp_quiz_pl_tab',
      cta: 'hp_quiz_pl_cta',
    },
  },
  [VerticalsEnum.business_loans]: {
    label: 'Business Loans',
    backgroundColor: '#bfebda',
    mainText:
      'Our Nerds researched 250+ small-business products so you don’t have to.',
    cta: {
      label: 'Find Business Loans',
      url: 'https://www.nerdwallet.com/redirect/d56b267e-073b-11ea-a8c5-179bb79b48c9',
    },
    images: {
      desktopURL: `${BASE_IMAGE_URL}/superbowl/shopping-1440-smb-2x.png`,
      tabletURL: `${BASE_IMAGE_URL}/superbowl/shopping-768-smb-2x.png`,
      mobileAltURL: `${BASE_IMAGE_URL}/superbowl/shopping-375-smb-new-2x.png`,
      alt: 'Small Business Hero Image',
    },
    analytics: {
      tab: 'hp_quiz_smb_tab',
      cta: 'hp_quiz_smb_cta',
    },
  },
  [VerticalsEnum.FinancialAdvisor]: {
    label: 'FINANCIAL ADVISOR',
    backgroundColor: '#95DCC3',
    mainText:
      'Our Nerds make it easy to connect with the best financial advisors for your situation.',
    cta: {
      label: 'Find Financial Advisors',
      url: 'https://www.nerdwallet.com/best/investing/financial-advisors',
    },
    images: {
      desktopURL: `${BASE_IMAGE_URL}/superbowl/heroes/shopping-1440-banking-2x.png`,
      tabletURL: `${BASE_IMAGE_URL}/superbowl/heroes/shopping-768-banking-2x.png`,
      mobileAltURL: `${BASE_IMAGE_URL}/superbowl/shopping_module_banking.png`,
      alt: 'Financial Advisor Hero Image',
    },
    analytics: {
      tab: 'hp_quiz_fa_tab',
      cta: 'hp_quiz_fa_cta',
    },
  },
};

/** zIndexes are defined by the selected tab.
 * For example: when PL is selected, Mortgages is ahead of Insurance and this is ahead of CC,
 *   but the tabs at the right of PL follows another pattern: SMB -> Banking -> Investing -> SL.
 */
export const SELECTED_TAB_Z_INDEX_VALUES = {
  [VerticalsEnum.Insurance]: {
    [VerticalsEnum.Insurance]: 100,
    [VerticalsEnum.CreditCards]: 90,
    [VerticalsEnum.Mortgages]: 80,
    [VerticalsEnum.PersonalLoans]: 70,
    [VerticalsEnum.business_loans]: 60,
    [VerticalsEnum.FinancialAdvisor]: 50,
  },
  [VerticalsEnum.CreditCards]: {
    [VerticalsEnum.Insurance]: 90,
    [VerticalsEnum.CreditCards]: 100,
    [VerticalsEnum.Mortgages]: 80,
    [VerticalsEnum.PersonalLoans]: 70,
    [VerticalsEnum.business_loans]: 60,
    [VerticalsEnum.FinancialAdvisor]: 50,
  },
  [VerticalsEnum.Mortgages]: {
    [VerticalsEnum.Insurance]: 90,
    [VerticalsEnum.CreditCards]: 80,
    [VerticalsEnum.Mortgages]: 100,
    [VerticalsEnum.PersonalLoans]: 70,
    [VerticalsEnum.business_loans]: 60,
    [VerticalsEnum.FinancialAdvisor]: 50,
  },
  [VerticalsEnum.PersonalLoans]: {
    [VerticalsEnum.Insurance]: 90,
    [VerticalsEnum.CreditCards]: 80,
    [VerticalsEnum.Mortgages]: 70,
    [VerticalsEnum.PersonalLoans]: 100,
    [VerticalsEnum.business_loans]: 60,
    [VerticalsEnum.FinancialAdvisor]: 50,
  },
  [VerticalsEnum.business_loans]: {
    [VerticalsEnum.Insurance]: 90,
    [VerticalsEnum.CreditCards]: 80,
    [VerticalsEnum.Mortgages]: 70,
    [VerticalsEnum.PersonalLoans]: 60,
    [VerticalsEnum.business_loans]: 100,
    [VerticalsEnum.FinancialAdvisor]: 50,
  },
  [VerticalsEnum.FinancialAdvisor]: {
    [VerticalsEnum.Insurance]: 90,
    [VerticalsEnum.CreditCards]: 80,
    [VerticalsEnum.Mortgages]: 70,
    [VerticalsEnum.PersonalLoans]: 60,
    [VerticalsEnum.business_loans]: 50,
    [VerticalsEnum.FinancialAdvisor]: 100,
  },
};
